import { connect } from "react-redux";
import HeaderComponent from "components/card/HeaderComponent";
import { TrendingUp } from "lucide-react";
import LineChartBase from "components/charts/LineChartBase";


const PerformanceTrend = ( props ) => {
  const { } = props;

const data = [
    { month: "May", score: 0 },
    { month: "Jun", score: 0 },
    { month: "Jul", score: 0 },
    { month: "Aug", score: 0 },
    { month: "Sep", score: 0 },
    { month: "Oct", score: 0 },
];

  
  	return (
        <HeaderComponent
          title="Performance Trend"
          labelIcon={<TrendingUp size={20}/>}
          description="Monthly performance scores over time"
        >
          <div className="px-6 pb-6 pt-2">
              <LineChartBase 
                  data={data} 
                  xKey="month" 
                  yKey="score" 
              />
          </div>
        </HeaderComponent>
);
};

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(PerformanceTrend);
